let clientsSwiperInstance = null;

export function initClientsSwiper() {
    const el = document.querySelector('.clients-swiper');
    if (!el) return;

    if (typeof window.Swiper === 'undefined') {
        console.warn('Swiper not loaded yet');
        return;
    }

    if (clientsSwiperInstance) {
        try {
            clientsSwiperInstance.destroy(true, true);
        } catch (e) {
            // Ignore errors on destroy
        }
        clientsSwiperInstance = null;
    }

    // Swiper from CDN bundle exposes everything in window.Swiper
    const Swiper = window.Swiper;
    const Autoplay = window.Swiper.Autoplay || window.Swiper.modules?.Autoplay;
    const FreeMode = window.Swiper.FreeMode || window.Swiper.modules?.FreeMode;

    clientsSwiperInstance = new Swiper(el, {
        modules: [Autoplay, FreeMode].filter(Boolean),
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 56,
        allowTouchMove: false,
        speed: 5000,
        freeMode: {
            enabled: true,
            momentum: false,
        },
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
    });
}
